import { render, staticRenderFns } from "./BorderArea.vue?vue&type=template&id=156626e3&scoped=true&"
var script = {}
import style0 from "./BorderArea.vue?vue&type=style&index=0&id=156626e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156626e3",
  null
  
)

export default component.exports